export default "__VITE_ASSET__nFD6Vmfj__"